export const CRASH_GAME = '/crash-game'
export const PLINKO_GAME = '/plinko-game'
export const PYRAMID_PLINKO_GAME = '/pyramid-plinko-game'
export const MINE_GAME = '/mine-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'

const NAMESPACES = {
  CRASH_GAME: '/crash-game',
  AZTECMAN_GAME: '/aztecman-game',
  FOLLOW_THE_ARROW_GAME: '/follow-the-arrow-game',
  POWER_OF_THOR_GAME: '/power-of-thor-game',
  CHAT: '/chat'
}

export default NAMESPACES
